import axios from 'axios';

const httpClient = axios.create({
  timeout: 5000,
  baseURL: process.env.VUE_APP_FSS_CORE,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ApplicationName: process.env.VUE_APP_NAME,
  },
});

function setDetfaults(baseUrl: string, country: string, language: string): void {
  httpClient.defaults.headers.Market = country;
  httpClient.defaults.headers.Language = language;
  httpClient.defaults.baseURL = baseUrl;
}

export default { setDetfaults };
export { httpClient };
